module.exports = __webpack_public_path__ + "static/media/YF44_1.491b3807.jpg";